var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DashboardCard',{attrs:{"width":_vm.width,"dataDisplay":_vm.dataDisplay,"main_icon":_vm.main_icon,"bgColor":_vm.bgColor,"icons":_vm.icon_data,"load_url":_vm.load_url,"hasLinks":_vm.hasLinks,"title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }